<template>
    <v-form ref="formRegister">
        <v-row>
            <v-col cols="12" class="mb-2">
                <v-row align="center" justify="center" class="flex-column">
                    <v-col cols="auto">
                        <v-img max-width="80px" contain src="/images/logo_roxo.png" />
                    </v-col>
                    <v-col cols="auto" class="text-center">
                        <span class="text-h5 font-weight-bold primary--text">Crie sua conta</span><br>
                        <span class="text-body-2 secondary--text">Preencha os dados abaixo</span>
                    </v-col>
                </v-row>
            </v-col>
            <v-col v-if="error_message" cols="12">
                <v-alert type="error" text dense rounded="xl">
                    {{ error_message }}
                </v-alert>
            </v-col>
            <v-col v-if="success_message" cols="12">
                <v-alert type="success" text dense rounded="xl">
                    {{ success_message }}
                </v-alert>
            </v-col>
            
            <template v-if="!success_message">
                <v-col cols="12" class="pb-0">
                    <span class="text-caption secondary--text font-weight-bold ml-1">Nome completo</span>
                    <v-text-field
                        v-model="form.name"
                        placeholder="Seu nome"
                        :disabled="loading"
                        :rules="name_rules"
                        color="primary"
                        background-color="background"
                        filled
                        rounded
                        dense
                        height="48"
                        class="mt-1"
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                    <span class="text-caption secondary--text font-weight-bold ml-1">Email</span>
                    <v-text-field
                        v-model="form.email"
                        placeholder="seu@email.com"
                        :disabled="loading"
                        :rules="email_rules"
                        color="primary"
                        background-color="background"
                        filled
                        rounded
                        dense
                        height="48"
                        class="mt-1"
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                    <span class="text-caption secondary--text font-weight-bold ml-1">Especialidade</span>
                    <v-select
                        v-model="form.service_id"
                        :items="services"
                        item-text="name"
                        item-value="id"
                        placeholder="Selecione sua especialidade"
                        :disabled="loading"
                        :rules="service_rules"
                        color="primary"
                        background-color="background"
                        filled
                        rounded
                        dense
                        height="48"
                        class="mt-1"
                    />
                </v-col>
                <v-col cols="12" class="py-0">
                    <span class="text-caption secondary--text font-weight-bold ml-1">Senha</span>
                    <v-text-field
                        v-model="form.password"
                        placeholder="********"
                        :disabled="loading"
                        :rules="password_rules"
                        type="password"
                        color="primary"
                        background-color="background"
                        filled
                        rounded
                        dense
                        height="48"
                        class="mt-1"
                    />
                </v-col>
                <v-col cols="12" class="pt-0">
                    <span class="text-caption secondary--text font-weight-bold ml-1">Confirme sua Senha</span>
                    <v-text-field
                        v-model="form.password_confirmation"
                        placeholder="********"
                        :disabled="loading"
                        :rules="password_confirmation_rules"
                        type="password"
                        color="primary"
                        background-color="background"
                        filled
                        rounded
                        dense
                        height="48"
                        class="mt-1"
                    />
                </v-col>
                <v-col cols="12" class="mt-2">
                    <v-btn 
                        color="primary" 
                        block 
                        large 
                        elevation="0" 
                        class="white--text text-capitalize rounded-xl" 
                        :loading="loading" 
                        :disabled="loading" 
                        @click="register"
                        height="48"
                    >
                        Criar Conta
                    </v-btn>
                </v-col>
            </template>
            
            <v-col cols="12" class="text-center mt-2">
                <span class="text-body-2 secondary--text">Já tem conta? </span>
                <a class="text-body-2 primary--text font-weight-bold" @click="$emit('change-view', 'LoginForm')">Voltar para o login</a>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
    data() {
        return {
            form: {
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
                service_id: null
            },
            services: [],
            loading: false,
            name_rules: [
                v => !!v || "Digite seu nome"
            ],
            email_rules: [
                v => !!v || "Digite um email",
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Digite um email válido"
            ],
            service_rules: [
                v => !!v || "Selecione uma especialidade"
            ],
            password_rules: [
                v => !!v || "Digite uma senha",
                v => (v && v.length >= 8) || "A senha deve ter no mínimo 8 caracteres"
            ],
            error_message: null,
            success_message: null
        };
    },
    computed: {
        password_confirmation_rules() {
            return [
                v => !!v || "Confirme sua senha",
                v => v === this.form.password || "As senhas não coincidem"
            ];
        }
    },
    mounted() {
        this.fetchServices();
        if (window.fbq) {
            window.fbq('track', 'Lead');
        }
    },
    methods: {
        ...mapActions("auth", ["ActionRegister", "ActionGetServices"]),
        async fetchServices() {
            try {
                const response = await this.ActionGetServices();
                this.services = response.data;
            } catch (error) {
                console.error("Erro ao buscar serviços:", error);
            }
        },
        async register() {
            if (this.$refs.formRegister.validate()) {
                this.loading = true;
                this.error_message = null;
                this.success_message = null;

                try {
                    const response = await this.ActionRegister(this.form);
                    this.success_message = response.data.message;
                    this.form = {
                        name: null,
                        email: null,
                        password: null,
                        password_confirmation: null,
                        service_id: null
                    };
                    this.$refs.formRegister.resetValidation();
                } catch (error) {
                    if (error?.response?.data?.error) {
                        this.error_message = error.response.data.error;
                    } else if (error?.response?.data?.message) {
                        this.error_message = error.response.data.message;
                    } else {
                        this.error_message = "Ocorreu um erro ao tentar criar a conta.";
                    }
                } finally {
                    this.loading = false;
                }
            }
        }
    }
};
</script>
